var map = {
	"./SCP_Studio_Collect_Logo_White.png": 477,
	"./VEVA-Cube-Glow (copy).png": 478,
	"./VEVA-Cube-Glow.png": 479,
	"./login-background.jpg": 480,
	"./logo-veva.svg": 195,
	"./logo.veva-collect-white.png": 481,
	"./new-logo.png": 121,
	"./ph.hero.projects.jpg": 482,
	"./ph.j+y.background.jpg": 483,
	"./ph.j+y.thumbnail.jpg": 484,
	"./ph.samokell.jpg": 485,
	"./studio-collect.svg": 486,
	"./user-icon.png": 487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;